import { render, staticRenderFns } from "./Narration.vue?vue&type=template&id=c7449abe&lang=html&"
import script from "./Narration.vue?vue&type=script&lang=js&"
export * from "./Narration.vue?vue&type=script&lang=js&"
import style0 from "./Narration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports